export class UserBillingConst {
  public static headerTable = [
    { field: 'transactionId', title: 'ID Transacción', cell: (row) => `${row.transactionId}`, class: (row) => `` },
    { field: 'date', title: 'Fecha', cell: (row) => `${new Date(row.date).toLocaleDateString()}`, class: (row) => `` },
    { field: 'subscriptionName', title: 'Subscripción', cell: (row) => `${row.subscriptionName}`, class: (row) => `` },
    { field: 'import', title: 'Importe', cell: (row) => `${row.import}`, class: (row) => `` }
  ];
}

export class UserBankAccountsConst {
  public static headerTable = [
    { field: 'accountNumber', title: 'Cuenta contable', cell: (row) => row.accountNumber ? `${row.accountNumber}` : ``, class: (row) => `` },
    { field: 'bank', title: 'Entidad', cell: (row) => `${row.bank}`, class: (row) => `` },
    { field: 'iban', title: 'IBAN', cell: (row) => `${row.iban}`, class: (row) => `` },
    { field: 'saldoContable', title: 'Saldo contable', cell: (row) => row.saldoContable ? `${row.saldoContable}` : '0', class: (row) => `` },
    // Nordigen en negociacion: oculto en el front. Para reactivarlo, descomentar.
    // {
    //   field: 'connected', title: 'Conectada', cell: (row) => {
    //     if (row.connected == null) {
    //       return "Cargando...";
    //     }
    //     else if (row.connected === true) {
    //       return "Si";
    //     }
    //     else {
    //       return "No";
    //     }
    //   }, class: (row) => ``
    // },
    {
      field: 'remesa', title: 'domiciliación bancaria (domiciliar)', cell: (row) => {
        if (row.remesa) {
          return "Si";
        } else {
          return "No";
        }
      }, class: (row) => ``
    },
    {
      field: 'taxationDefault', title: 'Para Impuestos', cell: (row) => {
        if (row.taxationDefault) {
          return "Si";
        } else {
          return "No";
        }
      }, class: (row) => ``
    }
  ];
}

export class MandateConst {
  public static headerTable = [
    { field: 'mandateRef', title: 'Referencia', cell: (row) => `${row.mandateRef}`, class: (row) => `` },
    {
      field: 'createDate', title: 'Fecha creación', cell: (row) => `${new Date(row.createDate).toLocaleDateString()}`,
      class: (row) => ``
    },
    { field: 'creditorName', title: 'Acreedor', cell: (row) => `${row.creditorName}`, class: (row) => `` },
    { field: 'debtorName', title: 'Deudor', cell: (row) => `${row.debtorName}`, class: (row) => `` },
  ];
}

export class AccountingModelConst {
  public static headerTable = [
    { field: 'name', title: 'Nombre cuenta', cell: (row) => `${row.name}`, class: (row) => `` },
    { field: 'number', title: 'Número cuenta', cell: (row) => `${row.number}`, class: (row) => `` },
    { field: 'type', title: 'Tipo cuenta', cell: (row) => `${row.type}`, class: (row) => `` },
    { field: 'accountGroup', title: 'Grupo cuenta', cell: (row) => `${row.accountGroup}`, class: (row) => `` }
  ];
}
